//@ts-nocheck
import DatePicker from "./AssetsDatePicker.vue";
import format from "date-fns/format";
import i18n from "@/i18n";
export default {
	methods: {
		onDateSelect(from, to) {
			this.setState({ open: false });
			this.from = from;
			this.to = to;
		},
		onClick(e) {
			this.setState({ open: !this.state.open });
		},
		setState(state) {
			this.state = { ...this.state, ...state };
		},
	},
	computed: {
		from: {
			get: function() {
				return this.$store.state.transactions.from;
			},
			set: function(newValue) {
				if(newValue) {
					this.$store.state.transactions.from = newValue;
				}
			},
		},

		to: {
			get: function() {
				return this.$store.state.transactions.to;
			},
			set: function(newValue) {
				if(newValue) {
					this.$store.state.transactions.to = newValue;
				}
			},
		},
	},
	data() {
		return {
			state: {
				open: false,
			},
		};
	},
	render: function(h) {
		return (
			<div class="transactions-date-picker">
				<div class="color-yellow">{i18n.t("date")}:</div>
				<button type="button" class="btn btn-date border-0 mr-0 text-left pl-0" onClick={this.onClick}>
					{i18n.t("from")} {format(this.from, "dd.MM.yyyy")} - {i18n.t("to")} {format(this.to, "dd.MM.yyyy")}
				</button>
				{this.state.open && <DatePicker props={{ onSelect: this.onDateSelect, fromDate: this.from, toDate: this.to }} />}
			</div>
		);
	},
};
